/** Amount strings from the API use a decimal point and optional thousands separators. */
export function hasNonZeroPrintAmount(value: string | number | null | undefined): boolean {
    if (value === null || value === undefined) {
        return false;
    }
    const normalized = String(value).trim().replace(/,/g, '');
    return /^[+-]?\d+(\.\d+)?$/.test(normalized) && Number.isFinite(Number(normalized)) && Number(normalized) !== 0;
}
